export const prettyFrenchDate = (date: Date, options?: Intl.DateTimeFormatOptions): string => {
  return date.toLocaleDateString(
    "fr-FR",
    options || {
      year: "numeric",
      month: "long",
      day: "numeric",
    }
  )
}
